export default __webpack_public_path__ + "static/media/waiting-room-studio.2a123d86.mp4";